module.exports = __webpack_public_path__ + "img/img_12.c3b8e659.svg";